export const GET_TIMETABLE_CATEGORIES = 'GET_TIMETABLE_CATEGORIES'
export const GET_TIMETABLE_SUBCATEGORIES = 'GET_TIMETABLE_SUBCATEGORIES'
export const GET_TIMETABLE_REPORT = 'GET_TIMETABLE_REPORT'
export const GET_TIMETABLE_SUBCATEGORY_BY_ID = 'GET_TIMETABLE_SUBCATEGORY_BY_ID'
export const ADD_CONSTRAINT_BY_ID = 'ADD_CONSTRAINT_BY_ID'
export const GET_ALL_CONSTRAINTS = 'GET_ALL_CONSTRAINTS'
export const DELETE_CONSTRAINT = 'DELETE_CONSTRAINT'
export const GET_CONSTRAINT_BY_ID = 'GET_CONSTRAINT_BY_ID'
export const UPDATE_CONSTRAINT = 'UPDATE_CONSTRAINT'
export const UPDATE_CONSTRAINT_LIST = 'UPDATE_CONSTRAINT_LIST'
export const GET_TIMETABLE = 'GET_TIMETABLE'
export const REQUEST_TIMETABLE = 'REQUEST_TIMETABLE'
export const DELETE_TIMETABLE = 'DELETE_TIMETABLE'
export const GENERATE_PROMPT = 'GENERATE_PROMPT'
export const VALIDATE_TIMETABLE = 'VALIDATE_TIMETABLE'
export const VALIDATE_TEACHER_AVAILABILITY = 'VALIDATE_TEACHER_AVAILABILITY'
export const GET_TIMETABLE_STATUS = 'GET_TIMETABLE_STATUS'
export const GET_TIMETABLE_STUDENT_SUBJECTS = 'GET_TIMETABLE_STUDENT_SUBJECTS'
export const LOG_SOCKET_MESSAGE = 'LOG_SOCKET_MESSAGE'
export const GENERATE_TIMETABLE_REPORT_PDF = 'GENERATE_TIMETABLE_REPORT_PDF'
export const ADD_NEW_DURATION = 'ADD_NEW_DURATION'
export const DELETE_DURATION = 'DELETE_DURATION'
export const GET_ALL_DURATIONS = 'GET_ALL_DURATIONS'
export const GET_TIMETABLE_LIST_DATA = 'GET_TIMETABLE_LIST_DATA'
export const GET_ALL_VERSIONS = 'GET_ALL_VERSIONS'
export const ACTIVATE_VERSION = 'ACTIVATE_VERSION'
export const DEACTIVATE_VERSION = 'DEACTIVATE_VERSION'
export const UPDATE_VERSION_NAME = 'UPDATE_VERSION_NAME'
export const UPDATE_DURATION = 'UPDATE_DURATION'
export const UPDATE_TIMETABLE = 'UPDATE_TIMETABLE'
export const GET_ACCESS_TOKEN = 'GET_ACCESS_TOKEN'
export const GET_WORK_BREAK_DOWN_BY_LEVEL_ID = 'GET_WORK_BREAK_DOWN_BY_LEVEL_ID'
export const UPDATE_WORK_BREAK_DOWN_FREQUENCY = 'UPDATE_WORK_BREAK_DOWN_FREQUENCY'
export const BULK_UPDATE_WORKLOAD = 'BULK_UPDATE_WORKLOAD'
export const GET_TIMETABLE_WARNING = 'GET_TIMETABLE_WARNING'
export const VALIDATE_CONCURRENT_SUBJECTS = 'VALIDATE_CONCURRENT_SUBJECTS'
export const CREATE_TIMETABLE_CLASS_VENUES = 'CREATE_TIMETABLE_CLASS_VENUES'
export const DELETE_TIMETABLE_VERSION = 'DELETE_TIMETABLE_VERSION'
export const VALIDATE_TIMETABLE_CAPACITY = 'VALIDATE_TIMETABLE_CAPACITY'
export const VALIDATE_SUBJECT_PAIRS_CONCURRENT = 'VALIDATE_SUBJECT_PAIRS_CONCURRENT'
export const GET_FREE_TEACHERS = 'GET_FREE_TEACHERS'
export const GET_FREE_VENUES = 'GET_FREE_VENUES'
export const DIAGNOSE_TIMETABLE_FAILURES = 'DIAGNOSE_TIMETABLE_FAILURES'
export const CALCULATE_TIMETABLE_TOKENS = 'CALCULATE_TIMETABLE_TOKENS'
export const CHECK_ALL_SUBJECTS_ENROLLMENT = 'CHECK_ALL_SUBJECTS_ENROLLMENT'
export const GET_RECENT_TIMETABLE_VERSIONS = 'GET_RECENT_TIMETABLE_VERSIONS'
export const VALIDATE_CLASS_SUBJECT_LOAD = 'VALIDATE_CLASS_SUBJECT_LOAD'
export const LOG_TIMETABLE_EXPORT = 'LOG_TIMETABLE_EXPORT'
export const TRACK_TIMETABLE_EVENT = 'TRACK_TIMETABLE_EVENT'
